import { z } from 'zod';

import { TFormData } from '../Quiz.helpers';

export const schema = (brand: string, formData: TFormData | null) => {
	const fnSchema = z
		.string({ invalid_type_error: 'Required' })
		.regex(/^[a-z]+$/i, 'First Name is required')
		.max(30);

	const lnSchema = z
		.string({ invalid_type_error: 'Required' })
		.regex(/^[a-z]+$/i, 'Last Name is required')
		.max(30);

	const emailSchema = z.string().email('Valid Email required');

	if (brand === 'ClearChoice') {
		const hasZipCode = formData?.form?.user_form?.fields?.some((field) => field.name === 'zip_code');
		const hasSMSOptIn = formData?.form?.user_form?.fields?.some((field) => field.name === 'sms_opt_in');
		const hasSMSMarketingOptIn = formData?.form?.user_form?.fields?.some((field) => field.name === 'sms_marketing');
		const hasSMSTransactionalOptIn = formData?.form?.user_form?.fields?.some((field) => field.name === 'sms_transactional');
		return z.object({
			first_name: fnSchema,
			last_name: lnSchema,
			email: emailSchema,
			phone: z.string().regex(/^\(\d{3}\) \d{3}-\d{4}$/, 'Valid Phone Number Required'),
			...(hasZipCode && {
				zip_code: z.coerce.string().regex(/^\d{5}$|^\d{5}-\d{4}$/, 'Valid ZIP Code Required'),
			}),
			...(hasSMSOptIn && {
				sms_opt_in: z.boolean(),
			}),
			...(hasSMSMarketingOptIn && {
				sms_marketing: z.boolean(),
			}),
			...(hasSMSTransactionalOptIn && {
				sms_transactional: z.boolean(),
			}),
		});
	}
	return z.object({
		firstName: fnSchema,
		lastName: lnSchema,
		email: emailSchema,
	});
};

export const defaultValues = (brand: string, formData: TFormData | null) => {
	if (brand === 'ClearChoice') {
		const hasZipCode = formData?.form?.user_form?.fields?.some((field) => field.name === 'zip_code');
		
		const hasSMSOptIn = formData?.form?.user_form?.fields?.some((field) => field.name === 'sms_opt_in');
		const hasSMSMarketingOptIn = formData?.form?.user_form?.fields?.some((field) => field.name === 'sms_marketing');
		const hasSMSTransactionalOptIn = formData?.form?.user_form?.fields?.some((field) => field.name === 'sms_transactional');
		return {
			first_name: '',
			last_name: '',
			email: '',
			phone: '',
			...(hasZipCode && { zip_code: '' }),
			...(hasSMSOptIn && { sms_opt_in: true }),
			...(hasSMSMarketingOptIn && { sms_marketing: true }),
			...(hasSMSTransactionalOptIn && { sms_transactional: true }),
		};
	}
	return {
		firstName: '',
		lastName: '',
		email: '',
	};
};
